import React, { useEffect, useState } from "react";
import { FaAngleDoubleUp } from "react-icons/fa";
import "./ScrollToTop.css";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    setVisible(scrolled > 100);
  };

  const scrollToTop = () => {
    const start = window.scrollY;
    const duration = 800; // Scroll duration in ms
    const delay = 300; // Delay before scroll starts

    const startTime = performance.now() + delay;

    const easeInQuad = (t) => t * t;
    const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      if (elapsed < 0) {
        requestAnimationFrame(animateScroll);
        return;
      }

      let progress = Math.min(elapsed / duration, 1);

      // Slow to fast easing
      let easedProgress =
        progress < 0.5
          ? easeInQuad(progress * 2) / 2
          : 0.5 + easeOutExpo((progress - 0.5) * 2) / 2;

      const position = start * (1 - easedProgress);
      window.scrollTo(0, position);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  return (
    <div
      className="scroll-to-top"
      onClick={scrollToTop}
      style={{ display: visible ? "flex" : "none" }}
    >
      <FaAngleDoubleUp className="icon" />
    </div>
  );
};

export default ScrollToTop;
